/**
 * LogoPrincipal.jsx
 *
 * Props:
 * ────────────────────────────────────────────────
 * size       → número. 1 = tamaño original (201×29 px). 2 lo duplica, 0.5 lo reduce a la mitad…
 * width      → número o string. Sobrescribe el ancho calculado.
 * height     → número o string. Sobrescribe el alto calculado.
 * className  → string.  Clases CSS extra (útil con Tailwind).
 * color      → string.  Color (currentColor por defecto).
 * prefix     → string.  Si es "_small" carga logo_small.svg; si está vacío carga logo.svg.
 * …props     → cualquier otro atributo válido de <img>.
 *
 * Prioridad: width/height  ›  size  ›  valor por defecto.
 */
import React from "react";
import logo from "../assets/logo.svg";
import logoSmall from "../assets/logo_small.svg";

const LogoPrincipal = ({
  size = 1,
  width,
  height,
  className = "",
  color = "currentColor",
  prefix = "",
  ...props
}) => {
  const BASE_W = 249;
  const finalWidth = width ?? BASE_W * size;

  const src = prefix === "_small" ? logoSmall : logo;

  return (
    <img
      src={src}
      alt="AuditCampaign logo"
      width={finalWidth}
      className={className}
      style={{ fill: color }}
      {...props}
    />
  );
};

export default LogoPrincipal;
